import React from "react";
import useConstrainable from "./use-constrainable";

export default function useWillClearConstrainOnUnmount(name) {

    const constrainable = useConstrainable();

    React.useEffect(() => () => {

        if(!constrainable) {
            return;
        }

        constrainable.setConstraint(name, null);
    }, []);

}
